export const fullCentreTitle = centre => "Westfield ".concat(centre.title, " Shopping Centre");